import User from 'models/user/user.model';
import TicketStatus from 'models/ticket-status/ticket-status.model';
import Project from 'models/project/project.model';
import TicketCategory from 'models/ticket-category/ticket-category.model';

export default class PaginatedList<T> {
    public page = 0;
    public limit = 0;
    public count = 0;
    public user: User = null;
    public status: TicketStatus = null;
    public interval: [number, number] = [null, null];
    public docs: T[] = [];
    public previous: { project: Project, page: number, limit: number, user: User, status: TicketStatus, interval: [number, number], category: TicketCategory, filter: string, district: number, searchables: any } = { project: new Project(), page: null, limit: null, user: new User(), status: null, interval: [null, null], category: null, filter: null, district: null, searchables: {} };

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.page) {
            this.page = Number(model.page);
        }
        if (model.limit) {
            this.limit = Number(model.limit);
        }
        if (model.count) {
            this.count = Number(model.count);
        }
        if (model.docs) {
            this.docs = model.docs;
        }
        if (model.user) {
            this.user = model.user;
        }
        if (model.status) {
            this.status = model.status;
        }
        if (model.interval) {
            this.interval = model.interval;
        }
        if (model.previous) {
            this.previous = model.previous;
        }
    }
}
